import { httpCreate } from './http';

const http = httpCreate('/srv/activity-links-relation');

export const activityLinksRelation = {
	// 获取直播设置--简介设置：多媒体联播
	getList(activityId, type) {
		return http.get(`/${activityId}/${type}`);
	},
	// 新增多媒体
	addLink(data) {
		return http.post('', data);
	},
	// 获取功能设置多媒体联播
	getMediaList(activityId, type, menuId) {
		return http.get(`/${activityId}/${type}/${menuId}`);
	},
	// 新增功能设置多媒体联播
	addMediaLink(menuId, data) {
		return http.post(`/${menuId}`, data);
	},
	// 编辑
	editLink(data) {
		return http.put('', data);
	},
	// 删除
	deleteLink(id) {
		return http.delete(`/${id}`);
	},
	sort(data) {
		return http.post('/sort', data);
	},
};
